import { isEmpty } from 'fp-ts/Record';
import { CommanderFormProps } from '@mews-commander/form';
import { FormRadioGroupField, lt } from '@mews/framework';
import { RadioButton, Stack, Typography } from '@optimus-web/core';
import { WithReservationId } from '@mews-commander/types';
import { NoteType, defaultGuestValues, defaultReservationValues, fieldNames } from '../schema';
import { useAddNoteFormControls } from '../hooks';
import { AccountsRecord } from '../../../../types';
import { AddReservationNoteFields } from './AddReservationNoteFields';
import { AddGuestNoteFields } from './AddGuestNoteFields';

export interface AddNoteDialogContentProps extends CommanderFormProps, WithReservationId {
    accountsRecord: AccountsRecord;
}

export const AddNoteDialogContent = ({ accountsRecord, reservationId, ...formProps }: AddNoteDialogContentProps) => {
    const isAccountsRecordEmpty = isEmpty(accountsRecord);
    const { renderFormContent, watch } = useAddNoteFormControls({
        ...formProps,
        defaultValues: isAccountsRecordEmpty ? defaultReservationValues : defaultGuestValues,
        reservationId,
    });

    const noteType = watch(fieldNames.noteType);

    return renderFormContent(
        <Stack vertical spacing="300">
            <FormRadioGroupField
                label={
                    <Typography textStyle="bodyLargeStrong" as="div">
                        {lt('Type')}
                    </Typography>
                }
                name={fieldNames.noteType}
            >
                <RadioButton label={lt('GuestInHouseReportAddNoteReservationType')} value={NoteType.reservation} />
                <RadioButton
                    label={lt('GuestInHouseReportAddNoteGuestType')}
                    value={NoteType.guest}
                    disabled={isAccountsRecordEmpty}
                />
            </FormRadioGroupField>
            {noteType === NoteType.reservation ? (
                <AddReservationNoteFields />
            ) : (
                <AddGuestNoteFields accountsRecord={accountsRecord} />
            )}
        </Stack>
    );
};
